// ABOUTME: Decides how the user-menu market section renders from the user's market context.
// ABOUTME: Hidden with the module off, single-choice with one market, empty list shows a placeholder.

import type { MarketContext } from '../types';

export type MarketSwitcherState =
    | { kind: 'hidden' }
    | { kind: 'empty' }
    | { kind: 'select'; disabled: boolean; value: string };

export const getMarketSwitcherState = (
    marketContext: MarketContext | null | undefined,
): MarketSwitcherState => {
    if (!marketContext) return { kind: 'hidden' };
    const { allowedMarkets, activeMarketId } = marketContext;
    if (allowedMarkets.length === 0) return { kind: 'empty' };
    const value = allowedMarkets.some(market => market.id === activeMarketId)
        ? (activeMarketId as string)
        : allowedMarkets[0].id;
    return { kind: 'select', disabled: allowedMarkets.length === 1, value };
};
